import { DEMO_FEATURES224, type DemoFeature224 } from '../domain/demoRestrictions224';

export interface DemoContext224 {
  demo: boolean;
  dataMode: string;
  tenantName?: string;
  restrictedFeatures: DemoFeature224[];
}

const EMPTY: DemoContext224 = { demo: false, dataMode: 'real', restrictedFeatures: [] };

function normalize(value: unknown): DemoContext224 {
  if (!value || typeof value !== 'object') return EMPTY;
  const raw = value as Partial<DemoContext224>;
  return {
    demo: Boolean(raw.demo),
    dataMode: String(raw.dataMode ?? 'real'),
    tenantName: raw.tenantName,
    restrictedFeatures: (Array.isArray(raw.restrictedFeatures) ? raw.restrictedFeatures : [])
      .filter((item): item is DemoFeature224 => DEMO_FEATURES224.includes(item as DemoFeature224)),
  };
}

/** Whether this session is a demo one, and what it may not do. */
export async function fetchDemoContext224(): Promise<DemoContext224> {
  try {
    const response = await fetch('/api/state', { headers: { Accept: 'application/json' } });
    if (!response.ok) return EMPTY;
    const payload = await response.json() as { demoContext?: unknown };
    return normalize(payload.demoContext);
  } catch {
    return EMPTY;
  }
}

export async function demoLogin224(role: 'child' | 'parent'): Promise<boolean> {
  try {
    const response = await fetch('/api/auth/demo-login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ role }),
    });
    return response.ok;
  } catch {
    return false;
  }
}
